
export const changePasswordGet = (changePasswordData) => {
    return changePasswordData.data
}

export const userNotificationsGet = (notificationData) => {
    return notificationData.data
}

export const userNotificationsPatch = (userNotificationsPatchData) => {
    return userNotificationsPatchData.data;
}
export const userChangePasswordApi = (ChangePasswordData) => {
    return ChangePasswordData.data
}
export const userDetailsGet = (data) => {
    return data.data
}
export const orgListingGet = (data) => {
    return data.data;
}
export const showNotificationGet = (data) => {
    return data.data;
}
export const chatHistoryListGet = (data) => {
    return data.data;
}
export const starUpdateData = (data) => {
    return data.data;
}
export const followUpPostGet = (data) => {
    return data.data;
}
export const customFieldLabelListsGet = (data) => {
    return data.data;
}
export const alltemplateListGet = (data) => {
    return data.data;
}
export const ondemandTemplateListsGet = (data) => {
    return data.data;
}
export const CampaignBroadcastingGet = (data) => {
    return data.data;
}
export const lastFromIdUpdateData = (data) => {
    return data.data;
}
export const userInformationUpdateGet = (data) => {
    return data.data;
}

export const ContactsListingGet = (data) => {
    return data.data;
}
export const nonExixtsCustomerCreate = (data) => {
    return data.data;
}
export const allgroupContactListsGet = (data) => {
    return data.data;
}
export const getGroupAndContactListGet = (data) => {
    return data.data;
}
export const clearChatHistoryGet = (data) => {
    return data.data;
}
export const userInformationCreate = (data) => {
    return data.data;
}
